import SectionShell from "@/pages/home/components/SectionShell";
import { resources } from "@/mocks/home";

const steps = [
  { num: "1", title: "先看在线观看", desc: "打开播放入口，快速确认是不是你要找的完整版。" },
  { num: "2", title: "再存高清资源", desc: "喜欢就保存未删减高清文件，随时离线回看。" },
  { num: "3", title: "最后收藏网盘", desc: "把百度云分享转存到自己的网盘，长期保存不丢失。" },
];

export default function ResourceSection() {
  return (
    <SectionShell
      id="resource"
      num="05"
      eyebrow="WATCH & DOWNLOAD"
      title="资源与网盘：观看入口集中在这"
      desc="完整版在线观看、未删减高清资源与百度云分享，三种方式并列摆好，按你的习惯挑一个就行。"
    >
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-7">
        {resources.map((item, idx) => (
          <article
            key={item.id}
            className={[
              "flex flex-col rounded-xl border p-6",
              idx === 0
                ? "border-primary-300/70 bg-primary-100/50"
                : "border-background-200/70 bg-background-50",
            ].join(" ")}
          >
            <div className="flex items-start justify-between">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-background-50 text-accent-600">
                <i className={`${item.icon} text-2xl`} />
              </span>
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                {item.badge}
              </span>
            </div>

            <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">
              {item.title}
            </h3>
            <p className="mt-3 flex-1 text-sm leading-7 text-foreground-600">{item.desc}</p>

            <ul className="mt-4 flex flex-wrap gap-2">
              {item.meta.map((m) => (
                <li
                  key={m}
                  className="rounded-md border border-background-200 bg-background-100 px-2.5 py-1 text-xs text-foreground-600"
                >
                  {m}
                </li>
              ))}
            </ul>

            <button
              type="button"
              className={[
                "mt-6 inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md px-5 py-3 text-sm font-medium transition-colors",
                idx === 0
                  ? "bg-primary-500 text-background-50 hover:bg-primary-600 dark:text-foreground-950"
                  : "border border-background-300 text-foreground-800 hover:border-accent-300 hover:bg-accent-50",
              ].join(" ")}
            >
              {item.action}
              <i className="ri-arrow-right-line" />
            </button>
          </article>
        ))}
      </div>

      <div className="mt-8 rounded-xl border border-background-200/70 bg-background-100 p-6">
        <div className="flex items-center gap-2">
          <i className="ri-route-line text-lg text-accent-500" />
          <h3 className="font-heading text-base font-bold text-foreground-950">
            三步走完整个观看流程
          </h3>
        </div>
        <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
          {steps.map((step) => (
            <div key={step.num} className="flex gap-3">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-500 font-heading text-sm font-bold text-background-50">
                {step.num}
              </span>
              <div>
                <p className="text-sm font-medium text-foreground-950">{step.title}</p>
                <p className="mt-1 text-xs leading-6 text-foreground-600">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionShell>
  );
}